"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
function batchExecutePromises(batchPromiseElements, passedOptions) {
    if (passedOptions === void 0) { passedOptions = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var options, elements, maxBatchSize, currentBatchSize, currentBatch, promises, responses, i, response, element;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    options = Object.assign({}, { maxBatchSize: 100 }, passedOptions);
                    elements = [].concat(batchPromiseElements);
                    maxBatchSize = options.maxBatchSize;
                    _a.label = 1;
                case 1:
                    if (!(elements.length > 0)) return [3 /*break*/, 7];
                    currentBatchSize = Math.min(elements.length, maxBatchSize);
                    currentBatch = elements.splice(0, currentBatchSize);
                    promises = currentBatch.map(function (element) {
                        return element.promiseFunc();
                    });
                    return [4 /*yield*/, Promise.all(promises.map(function (p) {
                            return p.catch ? p.catch(function (e) { return e; }) : p;
                        }))];
                case 2:
                    responses = _a.sent();
                    i = 0;
                    _a.label = 3;
                case 3:
                    if (!(i < responses.length)) return [3 /*break*/, 6];
                    response = responses[i];
                    if (!!(response instanceof Error)) return [3 /*break*/, 5];
                    element = currentBatch[i];
                    return [4 /*yield*/, element.responseFunc(response, element.identifier)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    i++;
                    return [3 /*break*/, 3];
                case 6: return [3 /*break*/, 1];
                case 7: return [2 /*return*/];
            }
        });
    });
}
exports.batchExecutePromises = batchExecutePromises;
//# sourceMappingURL=promise.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/utils/promise.js
// module id = 841
// module chunks = 1